<template lang="pug">
nav#site-nav
  //- div#styleSwitcher.switch(v-on:click="switchStyle")
  //-   div.peg(:style="{marginTop: this.isthedarkness ? '7px' : '1px' }")
  div.nav-items-container(:class="this.navVisible ? 'shown' : 'hidden'")
    //- div.nav-icon#contact(@click="this.handleContact")
      span.icon.icon-contact
    //- a.nav-icon#signin(href="#/contact")
    //-   span.icon.icon-signin(style="background-image: url('./assets/img/icon-signin.svg')") Sign in

    ol.nav-items(:class="this.navVisible ? 'shown' : 'hidden'")
      li.item(v-for="(n, i) in filteredPages" v-bind:css="true" :key="'nav_item' + i" @click="toggleNavVisibility")
        a(v-if="n.directRef" :href="n.directRef" :name="n.name") {{n.name}}
        router-link(v-if="!n.directRef" :to="{ name: 'pageScene', params: { page: n.slug }}") {{ n.name }}
  div#mobile-nav.nav-icon.medium(@click="this.toggleNavVisibility" :class="this.navVisible ? 'close' : 'open'")
    span.nav-icon-bar
    span.nav-icon-bar
    span.nav-icon-bar
  div#fixedNav
    router-link.brand.logo.medium(:to="{ name: 'defaultScene', params: { path: '/' }}" :style="{backgroundImage: `url(${this.logo})`}" )
    #itemsContainer
      router-link.fixedItem(v-for="(n,i) in shortMenu" :key="fixednavitem-`${n.fields.slug}`" :to="{ name: 'pageScene', params: {page: n.fields.slug} }") {{ n.fields.name }}
</template>

<script>
// router-link.fixedItem(:to="{ name: 'pageScene', params: {page: 'process'} }") Today
// router-link.fixedItem(:to="{ name: 'pageScene', params: {page: 'process', cid: ['60z8Mdf0UoSe4kq2aouMQa']} }") Future
// router-link.fixedItem(:to="{ name: 'pageScene', params: {page: 'contact'} }") Contact
// router-link.fixedItem(:to="{ name: 'pageScene', params: {page: 'cases'} }") Cases
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
// import anime from 'animejs'
import router from '@/router'

// component instance
var Navigation = Vue.component('navigation', {
  name: 'Navigation',
  props: [''],
  data: function () {
    return {
      navVisible: false
    }
  },
  watch: {
    'pages': function () {
      // console.log(this.pages)
    }
  },
  methods: {
    ...mapActions([
      'getEntry',
      'updateStyle'
    ]),
    switchStyle () {
      this.updateStyle()
    },
    toggleNavVisibility (event) {
      // console.log('toggle nav')
      this.navVisible = !this.navVisible
    },
    handleContact (event) {
      this.toggleNavVisibility()
      router.push({name: 'pageScene', params: {page: 'contact'}})
    }
  },
  computed: {
    logo () {
      // swiches logo based on page ( index = exception)
      return this.appData && this.appData.root
        ? !this.isthedarkness
          ? this.appData.root.fields.logo.file.url
          : this.appData.root.fields.logoAlt.file.url
        : null
    },
    shortMenu () {
      // COMBAK: gross implementation
      return this.appData && this.appData.global ? this.appData.global.items[0].fields.topMenu : null
    },
    filteredPages () {
      let filtered = {}

      for (var n in this.pages) {
        // console.log(n)
        this.pages[n].navigation && Vue.set(filtered, this.slug || this.pages[n].name.toLowerCase().split(' ').join('-'), this.pages[n])
      }

      return filtered
    },
    ...mapGetters([
      'appData',
      'domain',
      'pages',
      'isthedarkness'
    ])
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Navigation
</script>

<style lang="scss" scoped>
  #styleSwitcher{
    cursor: pointer;
    display: block;
    position: fixed;
    right: $body-gutter;
    top: measure(s);
    border: 1px solid get-color(primary);

    width: 8px;
    height: 16px;

    .peg{
      position: absolute;
      display: block;
      top: 0;
      background: get-color(primary);
      margin: 1px 0 0 1px;
      width: 4px;
      height: 6px;

      transition: margin .2s ease-out;
    }
  }
  // exception for logo styling on defaultScene i.e index
  nav{
    #itemsContainer{
      margin-top: #{measure(xs) + .4};
    }
    #fixedNav > #itemsContainer {
      opacity: 1;
      pointer-events: all;

      transition: opacity .2s ease-in-out;

      @include breakpoint(small only) {
        opacity: 0;
        pointer-events: none;
      }
    }
    #mobile-nav {
      opacity: 0;
      pointer-events: none;

      transition: opacity .2s ease-in-out;

      @include breakpoint(small only) {
        opacity: 1;
        pointer-events: all;
      }
    }
    .nav-icon{
      display: block;

      cursor: pointer;
      z-index: 9999;

      width: measure(s);
      height: measure(s);
      background-color: $body-background;
      border-bottom: 1px solid get-color(secondary);

      position: fixed;
      top: 0;
      left: 0;

      transition: background .2s ease-in-out, border-color .2s ease-in-out;

      // .icon{}
      // DEFAULT / OPEN ICON
      &.open{
        .nav-icon-bar{transform-origin: top left; transition: width .2s ease-in, transform .2s ease-in, opacity .2s ease-in;}
        &.small{
          width: measure(xs);
          height: measure(xs);
          // margin-right: #{measure(s) + measure(xxs) / 2};

          .nav-icon-bar{
            &:nth-child(1){transform: rotate(0deg); top: calc(40% + -2px)}
            &:nth-child(2){top: calc(40% + 2px)}
            &:nth-child(3){transform: rotate(0deg); top: calc(40% + 6px)}
          }
        }
        &.medium{
          width: measure(sm);
          height: 100px;
          // margin-right: #{measure(s) + measure(xxs) / 2};

          .nav-icon-bar{
            &:nth-child(1){transform: rotate(0deg); top: calc(50% + -4px)}
            &:nth-child(2){top: calc(50% + 0px)}
            &:nth-child(3){transform: rotate(0deg); top: calc(50% + 4px)}
          }
        }
      }
      // CLOSE ICON
      &.close{
        .nav-icon-bar{transform-origin: top left; transition: width .2s ease-in, transform .2s ease-in, opacity .2s ease-in;}
        &.small{
          width: measure(xs);
          height: measure(xs);
          // margin-right: #{measure(s) + measure(xxs) / 2};

          .nav-icon-bar{
            &:nth-child(1){transform: translate(6px, 0px) rotate(45deg); top: calc(40% + -2px)}
            &:nth-child(2){opacity: 0; top: calc(40% + 2px)}
            &:nth-child(3){transform: translate(6px, 4px) rotate(-45deg); top: calc(40% + 6px)}
          }
        }
        &.medium{
          width: measure(sm);
          height: 100px;
          // margin-right: #{measure(s) + measure(xxs) / 2};

          .nav-icon-bar{
            &:nth-child(1){transform: translate(6px, 0px) rotate(45deg); top: calc(50% + -4px)}
            &:nth-child(2){opacity: 0; top: calc(50% + 0px)}
            &:nth-child(3){transform: translate(6px, 4px) rotate(-45deg); top: calc(50% + 4px)}
          }
        }
      }

      &:hover{
        background: $white;
        border-color: $white;

        .nav-icon-bar{
          &:nth-child(1){width: #{40% * .55};}
          &:nth-child(2){width: 40% * .75;}
          &:nth-child(3){width: #{40%};}
        }
      }

      .nav-icon-bar{
        position: absolute;
        width: 40%;
        height: 2px;
        border-radius: 9999px;
        background-color: get-color(secondary);

        transition: width .1s ease-in;

        &:nth-child(1){top: calc(40% + -1px);  left: 32%; width: #{40% * .75};}
        &:nth-child(2){top: calc(40% + 4px); left: 32%; width: 40%;}
        &:nth-child(3){top: calc(40% + 9px); left: 32%; width: #{40% * .55};}
      }
    }

    #fixedNav{
      position: fixed;
      z-index: 9998;
      display: inline-flex;

      .logo{
        margin-right: measure(s);
        @include breakpoint(small only) {
          margin-right: measure(xxs);
        }
      }
    }
    .fixedItem {
      margin-top: measure(s) - .45;

      color: $body-font-color;
      font-size: font-measure(xs);

      margin-left: measure(xxs);

      white-space: nowrap;

      &:before{
        content: '';
        position: relative;
        display: inline-block;

        width: 6px;
        height: 6px;
        border: 2px solid get-color(primary);

        top: -2px;
        margin-right: #{measure(xxs) / 2};
      }
    }

    &#site-nav{
      transition: background .6s ease-out, color .8s ease-out;

      position: absolute;
      padding: .6rem 0;
      left: 0;
      width: 100%;
      height: 100px;
      // padding: 0 measure(sm);

      position: fixed;
      z-index: 9999;

      background: rgba($body-background, .75);

      -webkit-backdrop-filter: blur(8px);
      -moz-backdrop-filter: blur(8px);
      -o-backdrop-filter: blur(8px);
      -ms-backdrop-filter: blur(8px);
      backdrop-filter: blur(8px);

      &:after{
        content: '';
        position: absolute;
        display: block;

        height: 1px;
        width: 80%;

        left: 10%;
        top: 100px;

        background: $medium-gray;
      }

      .nav-items-container{
        display: flex;
        position: fixed;
        z-index: 9999;

        top: 0;
        left: 0;

        width: 100vw;
        height: 100vh;

        flex-grow: 1;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        // flex-flow: column no-wrap;

        background: get-color(primary);

        transition: opacity .3s ease-in-out;

        &.shown{
          opacity: 1;
          pointer-events: all;
        }
        &.hidden{
          opacity: 0;
          pointer-events: none;
        }

        a.nav-icon{color: $white}
        .nav-icon#signin, .nav-icon#login{
          font-family: $body-font-family;
          width: measure(m) + 1;
          padding: ((measure(xxs) +.2)/ 2) measure(xs) - .4;
          line-height: 1.7;

          @include breakpoint(small only){
            width: measure(s);
            color: transparent;
          }

          .icon:after{
            // color: $white;
            left: auto;
            right: calc(4% - #{$icon-size-small / 2});
          }
        }
      }

      .logo{
        margin-left: calc(#{$body-gutter});
        @include breakpoint(small only) {
          margin-left: calc(#{$body-gutter * 2});
        }
        // margin-left: (measure(xs));
        margin-top: calc(#{measure(xxs)} + 8px);
        min-width: measure(sm);
      }

      ol, ul, .nav-items{
        position: relative;
        top: 50%;
        transform: translate(0, -50%);

        @include breakpoint(small only) {
          top: 20%;
          transform: translate(0, -0%);
        }
        // margin-right: measure(s);
        // transition: opacity .3s ease-in-out;
        opacity: 1;
        // width: 100px;
        flex-wrap: wrap;
        justify-content: flex-end;

        &.shown{
          li, li.item{ opacity: 1; transform: translate(0, 0rem)}
        }
        &.hidden{
          li, li.item{ opacity: 0; transform: translate(0, 1rem)}
        }

        @include breakpoint (small only) {
          top: measure(sm);
        }

        @for $i from 1 through 10 {
          li:nth-child(#{$i}) {
            transition: opacity .2s #{.05 * $i}s ease-in-out, transform .2s #{.05 * $i}s ease-in-out;
          }
        }
        li, li.item{
          padding: 0 measure(xs);
          color: $white;
          font-size: font-measure(xxl);
          @include breakpoint(small only) { font-size: font-measure(l); }
          // vue active state
          &.router-link-active{
            font-weight: 700;
            text-decoration: underline;
          }
        }
        li a, li.item a{
          transition: color .8s ease-out;
          color: $white;
          font-size: font-measure(xxl);
          @include breakpoint(small only) { font-size: font-measure(l); }
          white-space: nowrap;
          // text-transform: uppercase;
          text-decoration: none;
          font-family: $body-font-family;
          &.router-link-active{
            font-weight: 700;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue